import axios, { AxiosInstance } from 'axios';
import { getPostHogTrackingHeaders } from 'scalarAnalytics/postHog';
import config from './config';
import setupInterceptorsTo from './interceptors/authorizationInterceptor';

const BASE_CONFIG = {
  baseURL: config.ApiUrl,
  headers: { 'Content-type': 'application/json' },
};

export const clientWithAuth: AxiosInstance = setupInterceptorsTo(axios.create(BASE_CONFIG));
export const clientWithoutAuth: AxiosInstance = axios.create(BASE_CONFIG);

// clientWithoutAuth skips the auth interceptor, but still tag requests with the PostHog
// session/person so pre-login backend events/errors link to the same session.
clientWithoutAuth.interceptors.request.use(requestConfig => {
  Object.entries(getPostHogTrackingHeaders()).forEach(([key, value]) => {
    // eslint-disable-next-line no-param-reassign
    requestConfig.headers[key] = value;
  });
  return requestConfig;
});
